import { Container as MUIContainer, styled } from '@mui/material';

import { PageBackground } from '@/components/Layout/Page/Page.styled';

export const Background = styled(PageBackground)(({ theme }) => ({
  paddingTop: `calc(${theme.layout.headerHeight.lg}px + ${theme.spacing(8)})`,
  paddingBottom: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
}));

export const Container = styled(MUIContainer)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
}));
